import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: images/background-check-icon.svg (history timeline).
export const BackgroundCheckHistoryIcon = forwardRef<
  SVGSVGElement,
  BaseIconProps
>(function BackgroundCheckHistoryIcon(props, ref) {
  return (
    <BaseIcon
      ref={ref}
      viewBox="0 0 14 13"
      fill="currentColor"
      stroke="none"
      {...props}
    >
      <path d="M5.91667 0.520813C6.04688 0.390605 6.20312 0.333313 6.375 0.333313C6.54688 0.333313 6.72396 0.390605 6.85417 0.520813L7.33333 0.99998L3.08333 5.24998L2.60417 4.77081C2.34375 4.5104 2.34375 4.09373 2.60417 3.83331L5.91667 0.520813Z" />
      <path d="M3.54167 5.70831L7.79167 1.47915L12.5 6.18748L8.27083 10.4375L3.54167 5.70831Z" />
      <path d="M8.72917 10.8958L12.9792 6.66665L13.4583 7.12498C13.7188 7.3854 13.7188 7.80206 13.4583 8.06248L10.1458 11.375C9.88542 11.6354 9.46875 11.6354 9.20833 11.375L8.72917 10.8958Z" />
      <path d="M2.60417 10.4375L4.95833 8.06248L5.91667 9.02081L3.54167 11.375C3.80208 11.6354 3.80208 12.0521 3.54167 12.3125L3.08333 12.7916C2.82292 13.0521 2.40625 13.0521 2.14583 12.7916L1.1875 11.8333C0.927083 11.5729 0.927083 11.1562 1.1875 10.8958L1.66667 10.4375C1.92708 10.1771 2.34375 10.1771 2.60417 10.4375Z" />
    </BaseIcon>
  );
});
